/* eslint-disable @typescript-eslint/no-useless-constructor */
import React, { Component } from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import InfoCircleIcon from 'mdi-react/InfoCircleIcon';
import { WithStyles } from 'decorators/withStyles';

interface IProps {
  classes?: any;
  message: string | React.ReactNode;
  type: 'success' | 'warning' | 'error' | 'info';
}

@WithStyles(() => ({
  snackbar: {
    marginBottom: 16,
    maxWidth: 'none',
    boxShadow: 'none',
    padding: '0 0 0 18px',
    color: '#37474F',
    fontWeight: 500
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },
  infoIcon: {
    marginRight: 15,
    fill: '#039BE5'
  },
  link: {
    color: '#37474F'
  },
  text: {
    flex: 1
  }
}))
export default class PopUp extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  render() {
    const { classes, type, message } = this.props;

    const backgroundColor = {
      success: '#D2EBD3',
      error: '#dc3f53',
      warning: '#FFF4D4',
      info: '#CDEBFA'
    };

    const icon = {
      success: <CheckCircleIcon size="35" className={classes.infoIcon} />,
      error: <CloseCircleIcon size="35" className={classes.infoIcon} />,
      warning: <InfoCircleIcon size="35" className={classes.infoIcon} />,
      info: <AlertOutlineIcon size="35" className={classes.infoIcon} />
    };

    return (
      <SnackbarContent
        className={classes.snackbar}
        style={{ backgroundColor: backgroundColor[type] }}
        message={
          <div className={classes.container}>
            {icon[type]}
            <div className={classes.text}>{message}</div>
          </div>
        }
      ></SnackbarContent>
    );
  }
}
